import { CouplePaginate, CoupleType, PairedPersonType, PairingResponse, PersonPaginate, PersonType } from "../types/PersonType";
import { useAPI } from "../hooks/useAPI";
import { OptionType, ResponseErrorType } from "../types/CommonType";
import { EventType } from "../types/EventType";
import moment from "moment";

export function EventModel() {
    const { api } = useAPI();

    const create = async (event: EventType) => {
        return new Promise<ResponseErrorType | EventType>((resolve) => {
            api()
                .post(`/api/event`, event)
                .then((resp) => {
                    resolve(resp.data.event);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const update = async (event_id: number, event: EventType) => {
        return new Promise<ResponseErrorType | EventType>((resolve) => {
            api()
                .put(`/api/event/${event_id}`, event)
                .then((resp) => {
                    resolve(resp.data.event);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const list = async (calendar_ids: string = "", options: any | undefined = undefined) => {
        return new Promise<boolean | EventType[]>((resolve) => {
            api()
                .get(`/api/event?calendar_ids=${calendar_ids}&${new URLSearchParams(options).toString()}`)
                .then((resp) => {
                    resolve(resp.data);
                })
                .catch(() => resolve(false));
        });
    }

    const get = async (event_id: number) => {
        return new Promise<EventType | boolean>((resolve) => {
            api()
                .get(`/api/event/${event_id}`)
                .then((resp) => {
                    resolve(resp.data);
                })
                .catch(() => resolve(false));
        });
    }

    const remove = async (event_id: number) => {
        return new Promise<boolean>((resolve) => {
            api()
                .del(`/api/event/${event_id}`)
                .then((resp) => {
                    resolve(true);
                })
                .catch(() => resolve(false));
        });
    }

    const generateTimeOptions = () => {
        const times = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const formattedHour = hour.toString().padStart(2, '0');
                const formattedMinute = minute.toString().padStart(2, '0');
                times.push({
                    key: `${formattedHour}:${formattedMinute}`,
                    value: `${formattedHour}:${formattedMinute}`,
                    label: `${formattedHour}:${formattedMinute}`
                });
            }
        }
        return times;
    }

    const generateDurationOptions = () => {
        const durations = [];
        for (let hour = 0; hour <= 6; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const totalMinutes = hour * 60 + minute;
                if (totalMinutes === 0) continue; // Skip 0 minutes
                const formattedHour = hour.toString().padStart(2, '0');
                const formattedMinute = minute.toString().padStart(2, '0');
                durations.push({
                    key: totalMinutes,
                    value: totalMinutes,
                    label: `${formattedHour}:${formattedMinute}h`
                });
            }
        }
        return durations;
    }

    const formatEventEndTime = (date: string, startTime: string, duration: number) => {
        const dateTime = moment(`${date} ${startTime}:00`, 'YYYY-MM-DD HH:mm:ss');
        const endTime = dateTime.add(duration, 'minutes');
        return endTime.format('YYYY-MM-DD HH:mm:ss');
    }

    return {
        create,
        update,
        remove,
        list,
        get,        
        generateTimeOptions,
        generateDurationOptions,
        formatEventEndTime
    };
}